import { baseApi } from '../../../core/baseApi';
import type { Invoice } from '../types';
import type { ApiResponse } from '../../../patterns/crud';

interface GetInvoicesArgs {
  limit?: number;
  offset?: number;
  status?: string;
}

export const invoicesApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // Get organization's invoices
    getInvoices: builder.query<{ invoices: Invoice[]; total: number }, GetInvoicesArgs | void>({
      query: (args) => ({
        url: '/billing/invoices',
        params: args || {},
      }),
      transformResponse: (response: ApiResponse<{ invoices: Invoice[]; pagination: { total: number } }>) => ({
        invoices: response.data?.invoices || [],
        total: response.data?.pagination?.total || 0,
      }),
      providesTags: (result) =>
        result?.invoices
          ? [
              ...result.invoices.map(({ id }) => ({ type: 'Invoices' as const, id })),
              { type: 'Invoices', id: 'LIST' },
            ]
          : [{ type: 'Invoices', id: 'LIST' }],
    }),

    // Get single invoice with line items
    getInvoice: builder.query<Invoice, string>({
      query: (id) => `/billing/invoices/${id}`,
      transformResponse: (response: ApiResponse<Invoice>) => response.data,
      providesTags: (result, error, id) => [{ type: 'Invoices', id }],
    }),
  }),
});

export const {
  useGetInvoicesQuery,
  useGetInvoiceQuery,
} = invoicesApi;
